import React from "react";

const ShortTermServiceAssessmentDetail = ({ item }) => {
    return (
        <>
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Presenting Problem. (Current Mental State and Presentation at Assessment)</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.presenting_problem}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Past Psychiatric History (From first presentation to current admission)</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.past_psychiatric}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>full family History (Any family illness, family contact)</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.family_history}</span>{" "}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Personal History (Childhood, School, Employment)</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.personal_history}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Social History (Accommodation, Social Network)</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.social_history}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%", verticalAlign: "top" }}>
                            <strong>Mental State Examination</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <table className="table table-bordered table-hover">
                                <tbody>
                                    {item.mental.map((m, idx) => (
                                        <tr key={idx}>
                                            <td style={{ width: "40%" }}>
                                                <strong>{m.key}</strong>{" "}
                                            </td>
                                            <td style={{ width: "60%" }}>
                                                <span className="text-primary">{m.value}</span>{" "}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Medical History (Please check those that apply and expend below)</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <ul className="text-primary">
                                {item.medical_history.map(i => (
                                    <li key={i}>{i} </li>
                                ))}
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Physical Health Check on Admission - complete and note any specific findings</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.physical_health_check}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Smoking Status</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.smoking_status}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Known Allergies</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.known_allergies}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Special Dietary Needs</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.special_dietary}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Any Issue with Medicines</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.issue_with_Medicine}</span>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Patient's Perception Of Needs and goals for this hospital admission</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <span className="text-primary">{item.patient_perception}</span>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%", verticalAlign: "top" }}>
                            <strong>Admission Tasks Completed</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <table className="table table-bordered table-hover">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Applicable</th>
                                        <th>Comments</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.admission_tasks.map(task => (
                                        <tr key={task.item}>
                                            <td>
                                                <strong>{task.item}</strong>
                                            </td>
                                            <td>{task.applicable ? <i className="material-icons text-success">check_circle</i> : <i className="material-icons text-danger">close</i>}</td>
                                            <td>
                                                <span className="text-primary">{task.comments}</span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "40%" }}>
                            <strong>Medication Prescribed</strong>
                        </td>
                        <td style={{ width: "60%" }}>
                            <table className="table table-bordered table-hover">
                                <tbody>
                                    <tr>
                                        <td>
                                            <strong>Regular</strong>
                                        </td>
                                        <td>
                                            <span className="text-primary">{item.medication_prescribed.regular}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <strong>PRN</strong>
                                        </td>
                                        <td>
                                            <span className="text-primary">{item.medication_prescribed.prn}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    );
};

export default ShortTermServiceAssessmentDetail;
